import React from 'react';
import ReactDOM from 'react-dom';
import Promise from 'bluebird';
import Immutable from 'immutable';
import History from 'flux-router-component/lib/History';
import queryString from 'query-string';

import Raven from './raven-config';
import './components/Html';
import Layout from './components/Layout';
import routes from './routes';
import Structure from './Structure';
import api, { RouteChangedError } from './api';
import title from './title';
import defaultData from './data';

Promise.longStackTraces();

if (typeof Raven !== 'undefined') {
  Promise.onPossiblyUnhandledRejection(function(error) {
    Raven.captureException(error);
  });
}

const history = new History();

const debug = require('debug')('pointblank:client');

const data = new Structure(defaultData);

function setRouteTo(route) {
  const newRoute = Immutable.fromJS({
    name: route.name,
    params: route.params || {},
    query: route.query || {}
  });
  if (Immutable.is(newRoute, data.cursor('route').deref())) {
    return;
  }
  data.cursor('route').set(newRoute);
  data.setIn(['request', 'baseUrl'], document.location.origin);
  data.setIn(['request', 'url'], document.location.href);
  data.setIn(['request', 'path'], document.location.pathname);
  data.setIn(['request', 'fullPath'], document.location.pathname + document.location.search);
}

function setTitle(data, route, parents) {
  history.setTitle(title(data, route, parents));
}

routes.navigateTo = async function(url, fromHistory = false, keepScroll = false, isRedirect = false) {
  const titleLevel1 = data.getIn(['title', 'prefix']);
  if (isRedirect) {
    history.replaceState({}, titleLevel1, url);
  }
  else if (!fromHistory) {
    history.pushState({}, titleLevel1, url);
  }
  if (!keepScroll) {
    window.scrollTo(0, 0);
  }

  api.navigatingStart();

  let route = routes.getRoute(url);
  if (!route) {
    const flatPage = data.getIn(['flatPages']).find(x => x.get('url') === url);
    if (flatPage) {
      route = {
        name: 'flatPage',
        params: { id: flatPage.get('id') }
      };
    } else {
      if (typeof Raven !== 'undefined') {
        Raven.captureMessage(url, { extra: { where: 'client.js:72', what: 'route not found' } });
      }
      route = routes.getRoute('/404');
    }
  }
  route.query = url.indexOf('?') !== -1
    ? queryString.parse(url.substr(url.indexOf('?')))
    : {};

  setRouteTo(route);

  try {
    await routes[route.name](data, route.params, route.query);
    api.navigatingEnd();
    const redirectTo = data.getIn(['redirectTo']);
    if (redirectTo) {
      data.setIn('redirectTo', null);
      routes.navigateTo(routes.makePath(redirectTo.get('name'), redirectTo.get('params').toJS()), false, false, true);
    }

    setTitle(data, route, [titleLevel1])
  } catch (error) {
    if (!(error instanceof RouteChangedError)) {
      if (typeof Raven !== 'undefined') {
        Raven.captureException(error, { extra: { where: 'client.js:95', what: `route ${url} did not resolve` } });
      }
      if (error.status === 404) {
        let route404 = routes.getRoute('/404');
        setRouteTo(route404);
      } else {
        console.error(`route ${route.name} failed, redirecting to 500`, error);
        let route500 = routes.getRoute('/500');
        setRouteTo(route500);
      }
    }
  }

};

history.on(() => {
  routes.navigateTo(history.getUrl(), true);
});

const container = document.getElementById('app');

function render() {
  async function signIn(query) {
    let response = await api.signin_4game({ "jwt_token": query['jwt'] });

    if (response.data) {
      data.cursor('user').set(response.data.user);
      data.cursor('team').set(response.data.team);
      // TODO should navigate to return url
      // https://trello.com/c/7pEVAJDh/432-returnurl
      routes.navigateTo('/');
    }
  }

  var url = history.getUrl();
  var query = url.indexOf('?') !== -1
    ? queryString.parse(url.substr(url.indexOf('?')))
    : {};

  if (query['jwt']) {
    signIn(query);
  }
  ReactDOM.render(<Layout data={data.cursor()}/>, container);
}

async function bootstrap() {
  const manifest = await api.manifest();

  data.setIn('flatPages', manifest.data.flatpages);
  data.setIn('user', manifest.data.user);
  data.setIn('team', manifest.data.team);
  data.setIn('banners', manifest.data.banners);

  let route = routes.getRoute(window.location.pathname);
  if (route) {
    route.query = queryString.parse(window.location.search);
  }

  data.setIn(['request', 'baseUrl'], document.location.origin);
  data.setIn(['request', 'url'], document.location.href);
  data.setIn(['request', 'path'], document.location.pathname);
  data.setIn(['request', 'fullPath'], document.location.pathname + document.location.search);

  if (!route) {
    const flatPage = data.getIn(['flatPages']).find(x => x.get('url') === window.location.pathname);
    if (flatPage) {
      route = { name: 'flatPage', params: { id: flatPage.get('id') } };
    } else {
      route = routes.getRoute('/404');
    }
  }

  try {
    await routes[route.name](data, route.params, route.query || {});
  } catch(err) {
    route = routes.getRoute('/500');
  }

  data.setIn('route', {
    name: route.name,
    params: route.params,
    query: route.query || {}
  });
}

(async function() {
  await bootstrap();
  debug('render');
  render();
  const indicator = document.getElementById('initial-indicator');
  indicator.parentNode.removeChild(indicator);
  data.on('change', render);
})();



// WEBPACK FOOTER //
// ./src/client.js